import type { CSSProperties } from "react";

export const sp = { xs: 4, sm: 8, md: 12, lg: 16, xl: 24, xxl: 32 };
export const radius = { sm: 4, md: 8, lg: 12, pill: 999 };

export const sidebarWrap: CSSProperties = {
  width: 350,
  flexShrink: 0,
  display: "flex",
  flexDirection: "column",
  gap: sp.md,
  overflow: "hidden",
};

export const customerListCard: CSSProperties = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  background: "var(--semi-color-bg-1)",
  borderRadius: radius.lg,
  border: "1px solid var(--semi-color-border)",
  overflow: "hidden",
  minHeight: 0,
};

export const profileCard: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  background: "var(--semi-color-bg-1)",
  borderRadius: radius.lg,
  border: "1px solid var(--semi-color-border)",
  overflow: "hidden",
  minHeight: 0,
  height: "100%",
};

export const customerListBody: CSSProperties = {
  flex: 1,
  overflow: "auto",
  padding: sp.sm,
  minHeight: 0,
};

export const templateCard: CSSProperties = {
  background: "var(--semi-color-bg-1)",
  borderRadius: radius.lg,
  border: "1px solid var(--semi-color-border)",
  padding: sp.md,
  maxHeight: 260,
  overflow: "auto",
};

export const chatWrap: CSSProperties = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  background: "var(--semi-color-bg-1)",
  borderRadius: radius.lg,
  border: "1px solid var(--semi-color-border)",
  overflow: "hidden",
  minWidth: 0,
  boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
};

export const pageWrap: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  height: "calc(100vh - 140px)",
  padding: sp.xs,
  background: "var(--semi-color-bg-0)",
  gap: sp.md,
  overflow: "hidden",
};

export const mainRow: CSSProperties = {
  flex: 1,
  display: "flex",
  gap: sp.lg,
  minHeight: 0,
};

export const brandHeader: CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: `${sp.sm} ${sp.lg}`,
  background: "linear-gradient(135deg, var(--semi-color-primary-light-default), var(--semi-color-bg-1))",
  borderRadius: radius.lg,
  border: "1px solid var(--semi-color-border)",
};

export const customerRowItem: CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: sp.sm,
  padding: `${sp.sm} ${sp.md}`,
  cursor: "pointer",
  borderRadius: radius.md,
  border: "1px solid transparent",
  background: "transparent",
  transition: "background .15s, border-color .15s, transform .15s",
};

export const avatar: CSSProperties = {
  width: 36,
  height: 36,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#fff",
  fontWeight: 600,
  fontSize: 14,
  flexShrink: 0,
  letterSpacing: 0,
};

export const intentionBadge: CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: 18,
  height: 18,
  padding: "0 5px",
  borderRadius: radius.sm,
  fontSize: 11,
  fontWeight: 700,
  color: "#fff",
  flexShrink: 0,
};

export const panelHeader: CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: `${sp.sm} ${sp.md}`,
  borderBottom: "1px solid var(--semi-color-border)",
  flexShrink: 0,
};

export const chatPanelSemi: CSSProperties = {
  flex: 1,
  minHeight: 0,
  height: "100%",
};

export const aiAvatarBg = "linear-gradient(135deg, #6C5CE7 0%, #8E7BFF 100%)";
export const userAvatarBg = "linear-gradient(135deg, #00B894 0%, #00CDC6 100%)";

/** 分值徽章背景色：>=80 优秀 / 60-79 良好 / 40-59 中等 / <40 低分 */
export function scoreBadgeColor(score?: number | null): string {
  if (score == null) return "#9ca3af";
  if (score >= 80) return "#22c55e";
  if (score >= 60) return "#0984E3";
  if (score >= 40) return "#f97316";
  return "#ef4444";
}

export const scoreBadgeStyle: CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: 34,
  height: 20,
  padding: "0 6px",
  borderRadius: radius.sm,
  fontSize: 12,
  fontWeight: 700,
  color: "#fff",
  flexShrink: 0,
  letterSpacing: 0.3,
};
